const QueryKeys = {
  alertConfigs: 'alert-configs',
  alerts: 'alerts',
  aliasSets: 'alias-sets',
  auditLogs: 'audit-logs',
  controllerLockMode: 'control-lock-mode',
  controlModeTemplates: 'control-mode-templates',
  datapointsSearch: 'datapoints-search',
  defaultStack: 'default-stack',
  allDevicesByType: 'all-devices-by-type',
  devices: 'devices',
  devicesParents: 'devices-parents',
  deviceTypes: 'device-types',
  distinctValues: 'distinct-values',
  events: 'events',
  getPagination: 'get-pagination',
  groups: 'groups',
  masterTracker: 'master-tracker',
  masterTrackerList: 'master-tracker-list',
  notes: 'notes',
  parentControllers: 'parent-controllers',
  unitControllers: 'unit-controllers',
  parentDevices: 'parent-devices',
  pointConfigs: 'point-configs',
  pointConfigsFiltered: 'point-configs-filtered',
  siteMeta: 'site-meta',
  stacks: 'stacks',
  trackers: 'trackers',
  user: 'user',
  userGroups: 'user-groups',
  users: 'users',
  widgetConfig: 'widget-config',
  widgetConfigInternal: 'widget-config-internal',
  widgetDeviceList: 'widget-device-list',
  widgets: 'widgets',
};

export default QueryKeys;
